const endpoints = {
  accounts: {
    autocomplete: 'users/v2/autocomplete',
    communications: 'v3/vendor-dashboard/accounts/communications',
    create: 'v3/vendor-dashboard/accounts',
    get: 'v3/vendor-dashboard/accounts/{id}',
    permissions: 'users/v2/:id/permissions',
    profile: 'vendor-dashboard/accounts/v2/:id',
    updateOrganization: 'users/v2/:id/parent',
    update: 'v3/vendor-dashboard/accounts',
    userInfo: 'vendor-dashboard/accounts/v2/user-info',
  },
  alerts: {
    user: 'v3/vendor-dashboard/alerts/user/:id',
    dismiss: 'v3/vendor-dashboard/alerts/dismiss/:id',
    clicked: 'v3/vendor-dashboard/alerts/clicked/:id',
  },
  billing: {
    history:
      'v3/vendor-dashboard/organizations/{organizationId}/billing-history',
    historyRefresh:
      'v3/vendor-dashboard/organizations/{organizationId}/billing-history/refresh',
  },
  checkout: {
    session:
      'v3/vendor-dashboard/checkout/{organizationId}/products/create-session',
    sessionStatus: 'v3/vendor-dashboard/checkout/session-status',
  },
  customers: {
    base: 'v3/vendor-dashboard/customers/:id',
    autocompleteVendors: 'vendor-dashboard/customers/v2/autocomplete',
  },
  catalog: {
    productImport:
      'vendor-dashboard/catalog-import/v2/:vendorId/product/:organizationProductId',
    productGroupImport:
      'vendor-dashboard/catalog-import/v2/:vendorId/product-group/:organizationProductGroupId',
    categoryImport:
      'vendor-dashboard/catalog-import/v2/:vendorId/category/:organizationCategoryId',
    productOptionImport:
      'vendor-dashboard/catalog-import/v2/:vendorId/product-option/:organizationProductOptionId',
    productSync:
      'organization-dashboard/products/v2/:id/refresh-vendor-products',
  },
  categories: {
    base: 'vendor-dashboard/categories/v2/:id',
    delete: 'vendor-dashboard/categories/v2/:id',
    search: 'vendor-dashboard/categories/v2',
    toggle: 'vendor-dashboard/categories/v2/:id/visible/:visible',
    organization: {
      base: 'organization-dashboard/categories/v2/:id',
      search: 'organization-dashboard/categories/v2',
      toggle: 'organization-dashboard/categories/v2/:id/visible/:visible',
      vendor: 'organization-dashboard/categories/v2/vendor/:vendorId',
      export: 'organization-dashboard/catalog-export/v2/category/:id',
    },
  },
  cms: {
    link: '/api/cms/link',
    retrieve: '/api/cms/retrieve',
    search: '/api/cms/search',
  },
  customerPortal: {
    fetchToken: 'v3/vendor-dashboard/tokens/customer-portal-token',
  },
  dietary: {
    base: 'vendor-dashboard/dietary-tags/v2/:id',
    search: 'vendor-dashboard/dietary-tags/v2',
  },
  cateringLeads: {
    feedback: 'v3/vendor-dashboard/event-leads/{id}/feedback',
    getPersonalized: 'v3/vendor-dashboard/event-leads/{id}/get-personalized',
    search: 'v3/vendor-dashboard/event-leads/search',
    isRunning: 'v3/vendor-dashboard/event-leads/is-running/{organizationId}',
    togglePin: 'v3/vendor-dashboard/event-leads/{id}/pinned/{pinned}',
    updateFeedback: 'v3/vendor-dashboard/event-leads/{id}/feedback',
    updateNotes: 'v3/vendor-dashboard/event-leads/{id}/update-notes',
    updateStatus: 'v3/vendor-dashboard/event-leads/{id}/update-status',
  },
  eventLeads: {
    feedback: 'v3/vendor-dashboard/event-leads/{id}/feedback',
    getPersonalized: 'v3/vendor-dashboard/event-leads/{id}/get-personalized',
    search: 'v3/vendor-dashboard/event-leads/search',
    isRunning: 'v3/vendor-dashboard/event-leads/is-running/{organizationId}',
    togglePin: 'v3/vendor-dashboard/event-leads/{id}/pinned/{pinned}',
    updateFeedback: 'v3/vendor-dashboard/event-leads/{id}/feedback',
    updateNotes: 'v3/vendor-dashboard/event-leads/{id}/update-notes',
    updateStatus: 'v3/vendor-dashboard/event-leads/{id}/update-status',
  },
  venueLeads: {
    feedback: 'v3/vendor-dashboard/venue-leads/{id}/feedback',
    getPersonalized: 'v3/vendor-dashboard/venue-leads/{id}/get-personalized',
    search: 'v3/vendor-dashboard/venue-leads/search',
    isRunning: 'v3/vendor-dashboard/venue-leads/is-running/{organizationId}',
    togglePin: 'v3/vendor-dashboard/venue-leads/{id}/pinned/{pinned}',
    updateFeedback: 'v3/vendor-dashboard/venue-leads/{id}/feedback',
    updateNotes: 'v3/vendor-dashboard/venue-leads/{id}/update-notes',
    updateStatus: 'v3/vendor-dashboard/venue-leads/{id}/update-status',
  },
  events: {
    autocomplete: 'vendor-dashboard/lots/v2/autocomplete',
    byLot: 'vendor-dashboard/events/v2/lot/:lotId',
    like: 'events/like/:id',
    lotSearch: 'vendor-dashboard/events/v2/search',
    search: 'vendor-dashboard/vendor-events/v2/search',
  },
  invoices: {
    create: 'invoices/v2/create',
    credit: 'invoices/v2/credit/:id',
    edit: 'invoices/v2/edit/:id',
    finalize: 'invoices/v2/:id/finalize/:tip',
    quote: {
      accept: 'invoices/v2/quote/:id/accept',
      create: 'invoices/v2/quote',
      edit: 'invoices/v2/quote/:id/edit',
      cancel: 'invoices/v2/quote/:id/cancel',
    },
    refund: 'invoices/v2/refund/:id',
    voidInvoice: 'invoices/v2/void/:id',
  },
  license: {
    delete: 'vendor-dashboard/vendors/v2/:vendorId/licenses/:id',
    list: 'admin-dashboard/licenses/v2',
    update: 'vendor-dashboard/vendors/v2/:vendorId/licenses',
  },
  lists: {
    newsletterTypes: {
      list: 'v3/vendor-dashboard/newsletter-types',
    },
  },
  locations: {
    byIP: 'https://ipapi.co/json',
    getCounty: 'https://geo.fcc.gov/api/census/area',
  },
  lots: {
    autocomplete: 'vendor-dashboard/lots/v2/autocomplete',
    base: 'vendor-dashboard/lots/v2/:id',
    events: {
      awaitingConfirmation:
        'event-dashboard/lots/v2/events/awaiting-confirmation/:id',
      confirmed: 'event-dashboard/lots/v2/events/confirmed/:id',
      interested: 'event-dashboard/lots/v2/events/interested/:id',
    },
    interest: {
      add: 'vendor-dashboard/lots/v2/:id/interest/add',
      remove: 'vendor-dashboard/lots/v2/:id/interest/remove',
    },
    search: 'lots/v2',
    updateOrganization: 'event-dashboard/lots/v2/:id/parent',
    vendorConfirm: 'vendor-dashboard/lots/v2/:id/confirm',
    vendorRejection: 'vendor-dashboard/lots/v2/:id/reject',
    bookVendor: 'vendor-dashboard/lots/v2/:id/select',
  },
  manage: {
    staff: {
      autocomplete: 'users/v2/autocomplete',
      create: 'vendor-dashboard/accounts/v2',
      get: 'v3/vendor-dashboard/accounts/{id}',
      remove: 'v3/vendor-dashboard/staff/{id}',
      search: 'users/v2',
      updateOrganization: 'users/v2/:id/parent',
      update: 'users/v2/{id}',
    },
  },
  orders: {
    base: 'orders/v2/:id',
    cancel: 'orders/cancel/:id',
    clear: 'orders/clear/:id',
    complete: 'orders/complete/:id/:transactionId',
    count: 'vendor-dashboard/order-search/v2/vendor/count',
    findCustomer: 'orders/customer',
    merchants: 'orders/merchants/:id',
    pickup: 'orders/pickup',
    prepare: 'orders/prepare/:id',
    promo: 'orders/promo/:code',
    ready: 'orders/ready/:id',
    receipt: {
      image: 'orders/receipt/image/:transactionId/:chefView',
    },
    refund: 'orders/refund/:id',
    remove: 'orders/remove/:id',
    reports: 'orders/export',
    search: 'vendor-dashboard/order-search/v2/vendor',
    send: {
      receipt: 'orders/send/receipt/:id',
      sms: 'orders/send/sms/:id',
    },
    track: {
      print: 'orders/track/print/:id',
    },
    transactions: 'orders/transactions',
    organization: {
      count: 'vendor-dashboard/order-search/v2/vendor/count',
    },
  },
  organizations: {
    accountStatus: 'v3/vendor-dashboard/organizations/:id/account-status',
    autocomplete: 'organization-dashboard/organizations/v2/autocomplete',
    autocompleteLotsAndOrganizations:
      'organization-structure/v2/lot-organization-autocomplete',
    autocompleteVendorsAndOrganizations:
      'organization-structure/v2/vendor-organization-autocomplete',
    agreements: 'v3/vendor-dashboard/organizations/:id/agreements',
    base: 'organization-dashboard/organizations/v2/:id',
    businessInfo: 'v3/vendor-dashboard/organizations/:id/business-info',
    createOnboardingLink:
      'v3/vendor-dashboard/organizations/:id/onboarding-link',
    createStripeAccount:
      'v3/vendor-dashboard/organizations/:id/create-stripe-account',
    orderingSettings: 'v3/vendor-dashboard/organizations/:id/ordering-settings',
    payoutIntervals: 'v3/vendor-dashboard/organizations/payout-intervals',
    personnel: 'users/v2',
    structure: 'organization-structure/v2/:id',
    structurev2: 'organization-dashboard/organizations/v2/:id/structure',
    updateOrganization: 'organization-dashboard/organizations/v2/:id/parent',
    contactDetails: 'organization-dashboard/contact-details/v2/:id',
    taxSettings: 'v3/vendor-dashboard/organizations/:id/tax-settings',
    documents: {
      delete: 'vendor-dashboard/organizations/v2/:organizationId/licenses/:id',
      search: 'vendor-dashboard/vendors/v2/:organizationId/licenses',
      update: 'vendor-dashboard/organizations/v2/:organizationId/licenses',
    },
  },
  payouts: {
    instant: 'vendor-dashboard/payouts/v2/instant/:vendorId', // TODO: Use v3 with organizationId
    report: 'v3/vendor-dashboard/payouts/:id',
    schedule: 'payouts/:vendorId/schedule/:intervalId',
    search: 'v3/vendor-dashboard/payouts',
    stripe: {
      connect: 'orders/stripe/connect/:id',
    },
  },
  pos: {
    capture: 'pos/capture/:vendorId',
    pay: 'pos/pay/:id',
    sales: 'pos/sales',
    token: 'pos/token/:id',
  },
  products: {
    base: 'vendor-dashboard/products/v2/:id',
    delete: 'vendor-dashboard/products/v2/:id',
    like: 'products/like/:id',
    search: 'vendor-dashboard/products/v2',
    toggle: 'vendor-dashboard/products/v2/:id/visible/:visible',
    autocomplete: 'vendor-dashboard/products/v2/autocomplete',
    menuSearch: 'vendor-dashboard/menu-search/v2',
    price: 'vendor-dashboard/products/v2/:id/price',
    organization: {
      base: 'organization-dashboard/products/v2/:id',
      search: 'organization-dashboard/products/v2',
      toggle: 'organization-dashboard/products/v2/:id/visible/:visible',
      vendor: 'organization-dashboard/products/v2/vendor/:vendorId',
      menuSearch: 'organization-dashboard/menu-search/v2',
    },
  },
  productOptions: {
    search: 'vendor-dashboard/product-options/v2',
    base: 'vendor-dashboard/product-options/v2/:id',
    organization: {
      base: 'organization-dashboard/product-options/v2/:id',
      search: 'organization-dashboard/product-options/v2',
      vendor: 'organization-dashboard/product-options/v2/vendor/:vendorId',
    },
  },
  productGroups: {
    search: 'vendor-dashboard/product-groups/v2',
    setDefault: 'vendor-dashboard/vendors/v2/:vendorId/default-menu/:id',
    base: 'vendor-dashboard/product-groups/v2/:id',
    toggle: 'vendor-dashboard/product-groups/v2/:id/visible/:visible',
    organization: {
      base: 'organization-dashboard/product-groups/v2/:id',
      search: 'organization-dashboard/product-groups/v2',
      toggle: 'organization-dashboard/product-groups/v2/:id/visible/:visible',
      vendor: 'organization-dashboard/product-groups/v2/vendor/:vendorId',
      export: 'organization-dashboard/catalog-export/v2/product-group/:id',
    },
  },
  profiles: {
    organization: 'vendor-dashboard/profiles/v2/organizations/:id',
    vendor: 'vendor-dashboard/profiles/v2/vendors/:id',
  },
  reports: {
    customerOverview: 'vendor-dashboard/order-reports/v2/customer-overview',
    items: 'vendor-dashboard/order-reports/v2/items',
    popularProducts: 'vendor-dashboard/order-reports/v2/popular-products',
    summary: 'vendor-dashboard/order-reports/v2/summary',
    trend: 'vendor-dashboard/order-reports/v2/trend',
  },
  schedule: {
    base: 'vendor-dashboard/schedules/v2/:id',
    count: 'vendor-dashboard/schedules/v2/count',
    add: 'vendor-dashboard/schedules/v2',
    lotSearch: 'event-dashboard/schedules/v2/search',
    search: 'vendor-dashboard/organization-schedules/v2/search',
    transfer: 'vendor-dashboard/schedules/v2/:scheduleId/transfer',
    walkups: 'vendor-dashboard/schedules/v2/:id/walkups',
    cancel: 'vendor-dashboard/schedules/v2/:id/cancel',
    enableOrdering: 'vendor-dashboard/schedules/v2/:id/enable-ordering',
    disableOrdering: 'vendor-dashboard/schedules/v2/:id/disable-ordering',
  },
  sites: {
    checkDomainAvailability:
      'v3/vendor-dashboard/organization-site-profiles/{organizationId}/domain-availability',
    get: 'v3/vendor-dashboard/organization-site-profiles/{organizationId}',
    getMenus:
      'v3/vendor-dashboard/organization-site-profiles/{organizationId}/get-menus',
    publish:
      'v3/vendor-dashboard/organization-site-profiles/{organizationId}/publish',
    removeHeroImage:
      'v3/vendor-dashboard/organization-site-profiles/{organizationId}/hero-image',
    removeLogoImage:
      'v3/vendor-dashboard/organization-site-profiles/{organizationId}/logo-image',
    unpublish:
      'v3/vendor-dashboard/organization-site-profiles/{organizationId}/unpublish',
    update: 'v3/vendor-dashboard/organization-site-profiles/{organizationId}',
    updateDomain:
      'v3/vendor-dashboard/organization-site-profiles/{organizationId}/domain',
    updateHeroImage:
      'v3/vendor-dashboard/organization-site-profiles/{organizationId}/hero-image',
    updateLogoImage:
      'v3/vendor-dashboard/organization-site-profiles/{organizationId}/logo-image',
    updateSocials:
      'v3/vendor-dashboard/socials/update-org-site-profile/{organizationId}',
  },
  stripe: {
    card: 'customers/card',
  },
  subscriptions: {
    active: 'v3/vendor-dashboard/subscriptions/organization/{organizationId}',
    addPaymentMethod:
      'v3/vendor-dashboard/payment-methods/organization/{organizationId}',
    cancel:
      'v3/vendor-dashboard/subscriptions/organization/{organizationId}/cancel',
    create: 'v3/vendor-dashboard/subscriptions/organization/{organizationId}',
    createCustomer: 'v3/vendor-dashboard/subscriptions/customer',
    getPaymentMethods:
      'v3/vendor-dashboard/payment-methods/organization/{organizationId}',
    getSubscriptionCustomer:
      'v3/vendor-dashboard/subscriptions/customer/:customerId',
    products: 'v3/vendor-dashboard/subscriptions',
    uncancel:
      'v3/vendor-dashboard/subscriptions/organization/{organizationId}/uncancel',
    update: 'v3/vendor-dashboard/subscriptions/organization/{organizationId}',
    updateAddons:
      'v3/vendor-dashboard/subscriptions/organization/{organizationId}/update/addons',
    updateDefaultPaymentMethod:
      'v3/vendor-dashboard/payment-methods/organization/{organizationId}/default',
  },
  territories: {
    get: 'vendor-dashboard/territories/v2',
    create: 'vendor-dashboard/territories/v2',
    update: 'vendor-dashboard/territories/v2/:id',
    delete: 'vendor-dashboard/territories/v2/:id',
  },
  user: {
    defaultVendor: 'users/v2/:userId/default-vendor/:vendorNameId',
    add: 'admin-dashboard/users/v2',
    base: 'users/v2/:id',
    availableRoles: 'users/v2/available-roles',
    search: 'users/v2',
    franchise: 'users/v2/franchise-users',
    messageSubscriptions:
      'v3/vendor-dashboard/users/{id}/message-subscriptions',
    messageTopics: 'v3/vendor-dashboard/users/{id}/message-topics',
  },
  vendors: {
    add: 'v3/vendor-dashboard/vendors',
    agreements: 'vendor-dashboard/vendors/v2/:id/agreements',
    autocomplete: 'vendor-dashboard/vendors/v2/autocomplete',
    base: 'vendor-dashboard/vendors/v2/:id',
    businessInfo: 'vendor-dashboard/vendors/v2/:id/business-info',
    frequentLocations: 'vendor-dashboard/vendors/v2/:id/frequent-locations',
    licenses: 'vendor-dashboard/vendors/v2/:id/licenses',
    public: 'public/vendors/v2/:id',
    customer: 'vendor-dashboard/customers/v2/:id/vendor/:vendorId',
    map: 'vendor-dashboard/vendors/v2/:id/map',
    orderingSettings: 'v3/vendor-dashboard/vendors/:id/ordering-settings',
    orderingSchedules: 'consumer-search/vendor',
    organizationPath: 'vendor-dashboard/vendors/v2/:id/organization-path',
    products: 'vendor-dashboard/products/v2',
    sendMarketing: 'vendor-dashboard/vendors/v2/send/marketing/:id',
    settings: 'vendor-dashboard/vendors/v2/settings',
    stripeDashboard: 'vendor-dashboard/vendors/v2/dashboard/stripe/:id',
    updateOrganization: 'vendor-dashboard/vendors/v2/:id/parent',
    events: {
      awaitingConfirmation:
        'vendor-dashboard/vendor-events/v2/awaiting-confirmation/:id',
      confirmed: 'vendor-dashboard/vendor-events/v2/confirmed/:id',
      interested: 'vendor-dashboard/vendor-events/v2/interested/:id',
    },
    toggle: 'vendor-dashboard/vendors/v2/:id/visible/:visible',
    getVendorsInOrganization:
      'vendor-dashboard/vendors/v2/organization/:id/vendors',
    summary: 'vendor-dashboard/vendors/v2/:id/summary',
    taxes: 'vendor-dashboard/vendors/v2/:id/taxes',
  },
};

export default endpoints;
